import { useChatStore } from '@/store/chatStore'
import { SUPPORTED_LANGUAGES } from '@/types'

// ─────────────────────────────────────────────
// LanguageSelector
// Dropdown shown in ChatHeader.
// Updates selectedLanguage in store — useChat
// picks it up and sends it as responseLanguage
// in every AskQuestionRequest.
// ─────────────────────────────────────────────

export function LanguageSelector() {
  const selectedLanguage = useChatStore((s) => s.selectedLanguage)
  const setLanguage      = useChatStore((s) => s.setLanguage)
  const isStreaming      = useChatStore((s) => s.isStreaming)

  return (
    <select
      value={selectedLanguage}
      onChange={(e) => setLanguage(e.target.value)}
      disabled={isStreaming}
      title="Response language"
      className="
        text-xs rounded-md px-2 py-1 border
        bg-[var(--color-input-bg)]
        border-[var(--color-border)]
        text-[var(--color-text)]
        disabled:opacity-50 disabled:cursor-not-allowed
        focus:outline-none focus:ring-2 focus:ring-[var(--color-brand)]
        cursor-pointer
      "
    >
      {SUPPORTED_LANGUAGES.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.flag} {lang.label}
        </option>
      ))}
    </select>
  )
}